export const propInfo = {
  name: {
    saveSuccess: "تم حفظ اسم مكان الإقامة بنجاح",
    successTitle: "نجاح",
    saveError: "تعذّر حفظ اسم مكان الإقامة",
  },
  capacity: {
    saveSuccess: "تم حفظ السعة بنجاح",
    saveError: "تعذّر حفظ السعة",
  },
  location: {
    loadError: "تعذّر تحميل بيانات الإعلان.",
    appliedBulk: "تم تطبيق الموقع على {count} أماكن إقامة مرتبطة",
    saveSuccess: "تم حفظ الموقع بنجاح",
    partialError: "تعذّر تحديث بعض أماكن الإقامة",
    savePropertySuccess: "تم حفظ موقع مكان الإقامة بنجاح",
    saveError: "تعذّر حفظ موقع مكان الإقامة",
    loading: "جارٍ تحميل موقع الإعلان…",
    noUnitsTitle: "لا يحتوي هذا الإعلان على وحدات بعد.",
    noUnitsText: "أنشئ وحدة واحدة على الأقل لإعداد الموقع.",
    bulkNotice: "سيُطبَّق هذا التغيير على {count} أماكن الإقامة المرتبطة بـ {name}.",
  },
  description: {
    saveSuccess: "تم حفظ الوصف بنجاح",
    saveError: "تعذّر حفظ الوصف",
    cloneTitleNoun: "الوصف",
    cloneItemNoun: "الوصف",
  },
};
